import SVG from './SVG'

export const DoubleQuotes2SVG = (props) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      fill="none"
      viewBox="0 0 13 12"
      {...props}
    >
      <g className="double_quotation_marks_right" clipPath="url(#a)">
        <path
          fill="#9B9B9B"
          d="M11.148 11.916c-1.056-.704-2.256-1.168-3.6-1.392-.128-.32-.224-.784-.288-1.392-.096-.608-.128-1.136-.096-1.584 1.408-.096 2.112-.88 2.112-2.352 0-.64-.176-1.408-.528-2.304a12.302 12.302 0 0 0-1.344-2.4c.224-.16.528-.288.912-.384.384-.096.704-.128.96-.096a15.224 15.224 0 0 1 2.592 3.984c.608 1.472.912 2.896.912 4.272 0 1.728-.544 2.944-1.632 3.648Zm-7.104-.144c-.96-.672-2.176-1.136-3.648-1.392-.128-.32-.224-.768-.288-1.344a6.103 6.103 0 0 1-.096-1.488c1.472-.096 2.208-.88 2.208-2.352 0-.608-.176-1.344-.528-2.208A17.67 17.67 0 0 0 .348.588C.572.428.876.3 1.26.204c.352-.096.672-.128.96-.096 1.088 1.248 1.936 2.56 2.544 3.936.608 1.376.912 2.736.912 4.08 0 1.76-.544 2.976-1.632 3.648Z"
          className="quotes2"
        />
      </g>
      <defs>
        <clipPath id="a" className="a">
          <path fill="#fff" d="M0 0h13v12H0z" />
        </clipPath>
      </defs>
    </SVG>
  )
}
